import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _t from "../models/identifier.js";
import { getByteLength as U } from "../util/string-utils.js";
import ei from "../models/push-token.js";
import r from "../../shared-lib/braze-shared-lib.js";
import { STORAGE_KEYS as o } from "../managers/storage-manager.js";
import { User } from "../User/index.js";

var bt = /*#__PURE__*/function () {
  function bt(t, s) {
    _classCallCheck(this, bt);

    this.gt = t, this.h = s;
  }

  _createClass(bt, [{
    key: "getUserId",
    value: function getUserId() {
      var t = this.h.tu(o.iu.su);
      if (null == t) return null;
      var s = t.eu,
          i = U(s);

      if (i > User.ee) {
        for (; i > User.ee;) {
          s = s.slice(0, s.length - 1), i = U(s);
        }

        t.eu = s, this.h.ru(o.iu.su, t);
      }

      return s;
    }
  }, {
    key: "uu",
    value: function uu(t) {
      var s = null == this.getUserId();
      this.h.ru(o.iu.su, new _t(t)), s && this.h.ou(t);
    }
  }, {
    key: "setCustomUserAttribute",
    value: function setCustomUserAttribute(t, s) {
      if (this.gt.hu(t)) return r.D.info('Custom Attribute "' + t + '" is blocklisted, ignoring.'), !1;
      var i = {};
      return i[t] = s, this.nu(User.lu, i, !0);
    }
  }, {
    key: "nu",
    value: function nu(t, s, i, e) {
      var u = this.h.mu(this.getUserId(), t, s);
      return !e && u && r.D.info("Logged".concat(i ? " custom" : "", " attribute ").concat(t, " with value ").concat(s)), u;
    }
  }, {
    key: "Gr",
    value: function Gr(t, s, i, e, u) {
      this.nu("push_token", t, !1, !0), this.nu("custom_push_public_key", i, !1, !0), this.nu("custom_push_user_auth", e, !1, !0), this.nu("custom_push_vapid_public_key", u, !1, !0);
      var h = r.xt.Ft,
          n = new r.qt(h, r.D),
          l = new ei(t, s, i, e, u);
      this.h.B(o.q.gn, l.ss()), n.setItem(h.$t.pu, h.se, !0);
    }
  }, {
    key: "Jr",
    value: function Jr(t) {
      if (this.nu("push_token", null, !1, !0), this.nu("custom_push_public_key", null, !1, !0), this.nu("custom_push_user_auth", null, !1, !0), this.nu("custom_push_vapid_public_key", null, !1, !0), t) {
        var _t2 = r.xt.Ft,
            s = new r.qt(_t2, r.D);
        this.h.B(o.q.gn, !1), s.setItem(_t2.$t.pu, _t2.se, !1);
      }
    }
  }]);

  return bt;
}();

export { bt as default };